module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAAx0lEQVQokY3OPQrCQBCG4dcg2+QeW4popUVUAt7EI2yhB7Bwz2DrHQTxp7C1EY0seA3RNYjNBmJI4k41MzzMfI1wvoqBWFkzo6YCYAlMtZC7f/Dj+qEW8lgHX7m5r4U8VMFiRVrIjQ8EiIuXq2B2ee8DAQZayK0PBBhpIdc+EGDsC71eA5x84AWImn9QArSVNWndxRvQUdakUJ3x7NAzW5S9ToCusuadXwaAyM13l+kHZTB0/RVoKWtsWZYAmAALoKeseVRk5gtAdTWJn1hZdgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/更多.png
// module id = JUY1
// module chunks = 1